export const POST_CONSTS = {
    GET_POSTS: "GET_POSTS",
    GET_POST_BY_ID: "GET_POST_BY_ID",
    ADD_POST: "ADD_POST",
    UPDATE_POST: "UPDATE_POST",
    TOGGLE_POST_VISIBILITY: "TOGGLE_POST_VISIBILITY",
    DELETE_POST: "DELETE_POST",
};
